import { uploadData, getUrl, remove, list, copy } from '@aws-amplify/storage';

export function getLogo (logo, success) {
  getUrl({path: `public/logos/${logo}`}).then(
    ({ url }) => success && success(url?.href),
    err => console.log("err", err)
  );
}
export async function updateLogo(logoName, logoContent, logoType, success, failure) {
  await uploadData({
    path: 'public/logos/'+logoName,
    data: logoContent,
    options: {
      // accessLevel: "public",
      contentType: logoType,
    }
  });
}

export async function deleteLogo(organizationId, logoType) {
  await remove({
    path: 'public/logos/'+organizationId+logoType,
    // options: {
    //   accessLevel: "public",
    // }
  });
}

export async function getCertificateFiles(certificateId, files, success) {
  const result = []
  await Promise.all(files?.map(async file => {
    let name = file;
    let path;
    if(typeof file !== "string") {
      if(file.fullPath) {
        // Handle supplemental files with fullPath
        name = file.name;
        path = `${certificateId}/${file.fullPath}`;
      } else if(file.isAcord25) {
        name = file.name;
        path = `${certificateId}/acord25/${name}`;
      } else {
        name = file.name || file;
        path = `${certificateId}/${name}`;
      }
    } else {
      path = `${certificateId}/${file}`
    }
    const { url } = await getUrl({
      path: `protected/certificates/${path}`,
    })
    result.push({
      name,
      content: url.toString(),
      isAcord25: file.isAcord25,
      isSupplementalCoiFile: file.isSupplementalCoiFile
    })
    return Promise.resolve()
  }))
  success && success(result)
  return result;
}

export async function getCertificateSupplementalCoiFiles(certificateId, supplementalCoiFiles, success) {
  const result = { ...supplementalCoiFiles };
  const supplementalCoverageCoiFilesArray = Object.entries(supplementalCoiFiles).flatMap(([insuranceType, documents]) =>
    Object.entries(documents).map(([documentType, fileData]) => ({
      fullPath: `SupplementalCoverageDocumentation/${insuranceType}/${documentType}/${fileData}`,
      isNew: fileData.isNew,
      insuranceType,
      documentType,
      name: fileData,
      isSupplementalCoiFile: true,
    }))
  );
  await Promise.all(supplementalCoverageCoiFilesArray?.map(async file => {
    let path = `protected/certificates/${certificateId}/${file.fullPath}`
    const { url } = await getUrl({
      path,
    })
    result[file.insuranceType][file.documentType] = {
      name: file.name,
      content: url.toString(),
      isSupplementalCoiFile: true,
    };
    return Promise.resolve()
  }))
  success && success(result)
  return result;
}

export async function uploadCertificateFile(certificateId, identityId, fileName, fileContent, scanId) {
  const options = {
    contentType: "application/pdf",
  }
  const filePath = (identityId === 'scanning') ? `input/${certificateId}/${scanId}/${fileName}` : `${certificateId}/${fileName}`
  const fetched = await fetch(fileContent)
  const blobbed = await fetched.blob()
  try {
    const result = await uploadData({
      path: `protected/${identityId}/${filePath}`,
      data: blobbed,
      options
    })
    return result
  } catch(e) {
    console.log("e", e)
  }
}

export async function uploadCertificateSupplementalCoiFile(certificateId, insuranceType, documentType, fileName, fileContent) {
  const options = {
    contentType: "application/pdf",
  }
  const filePath = `protected/certificates/${certificateId}/SupplementalCoverageDocumentation/${insuranceType}/${documentType}/${fileName}`;
  const fetched = await fetch(fileContent)
  const blobbed = await fetched.blob()
  try {
    const result = await uploadData({
      path: filePath,
      data: blobbed,
      options
    })
    return result
  } catch(e) {
    console.log("e", e)
  }
}

export async function uploadUsingPresignedUrl(preSignedUrl, fileContent, onProgress) {
  const fetched = await fetch(fileContent)
  const blobbed = await fetched.blob()
  
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    
    // Track upload progress
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && onProgress) {
        const percentComplete = Math.round((event.loaded / event.total) * 100);
        onProgress(percentComplete);
      }
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response);
      } else {
        reject(new Error(`Upload failed with status: ${xhr.status}`));
      }
    };

    xhr.onerror = (e) => reject(new Error('Upload failed',e));
    xhr.onabort = (e) => reject(new Error('Upload aborted',e));

    xhr.open('PUT', preSignedUrl, true);
    xhr.send(blobbed);
  });
}

export async function copyScannedAcord25(certificateId, scanId, fileName) {
  await copy({
    source: {
      path: `protected/scanning/input/${certificateId}/${scanId}/${fileName}`,
    },
    destination: {
      path: `protected/certificates/${certificateId}/acord25/${fileName}`,
    }
  });
}

export async function getFailedScanFile(certificateId, scanId, fileName, success) {
  try {
    const { url } = await getUrl({
      path: `protected/scanning/input/${certificateId}/${scanId}/${fileName}`,
    });
    const result = [{
      name: fileName,
      content: url.toString(),
      isAcord25: true,
    }];
    success && success(result);
    return result;
  } catch (error) {
    console.error('Error getting failed scan file:', error);
    return [];
  }
}

export async function deleteCertificateFile(certificateId, fileName) {
  const result = await remove({
    path: `protected/certificates/${certificateId}/${fileName}`,
  });
  return result;
}

export async function deleteCertificateSupplementalCoiFile(certificateId, insuranceType, documentType, fileName) {
  const filePath = `protected/certificates/${certificateId}/SupplementalCoverageDocumentation/${insuranceType}/${documentType}/${fileName}`;
  const result = await remove({
    path: filePath,
  });
  return result;
}

export async function deleteCertificateFromS3(certificateId) {
  const certificateFiles = await list({
    path: `protected/certificates/${certificateId}/`,
  });
  console.log('removeCertificateFromS3', certificateFiles)
  
  await Promise.all(certificateFiles?.items?.map(async file => {
    await remove({
      path: `protected/certificates/${file.key}`,
      });
    return Promise.resolve();
  }));
    
  // Get and delete files from /protected/scanning/input
  const scanningInputFiles = await list({
    path: `protected/scanning/input/${certificateId}/`,
    });
  
  await Promise.all(scanningInputFiles?.items?.map(async file => {
    await remove({
      path: `protected/scanning/input/${file.key}`,
      });
    return Promise.resolve();
  }));
  
  // Get and delete files from /protected/scanning/output
  const scanningOutputFiles = await list({
    path: `protected/scanning/output/${certificateId}/`,
    });
    
    await Promise.all(scanningOutputFiles?.items?.map(async file => {
      await remove({
        path: `protected/scanning/output/${file.key}/`,
    });
    return Promise.resolve();
  }));
}
